import Vue from 'vue';
import Buero from './Buero';
import Campus from './Campus';
import PDFViewer from './PDFViewer';
import MerchantList from './MerchantList';

Vue.component('buero', Buero)
Vue.component('campus', Campus)
Vue.component('pdf-viewer', PDFViewer)
Vue.component('merchant-list', MerchantList)
